<template>
    <div class="post-categories" v-if="currentPage && currentPage.acf">
        <ul class="cat-list">
            <li v-if="currentPage.acf.education_level">
                <span class="icon">
                    <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <circle fill="#fff" cx="15" cy="15" r="15"></circle>
                        <path fill="#005782" transform="translate(5.000000, 5.000000)" d="M15.5704388,8.92036952 C17.6915473,8.67722864 19.345358,6.87288684 19.345358,4.68734411 C19.345358,2.52004619 17.7184296,0.729330254 15.6224018,0.462355658 C15.580739,0.200554273 15.355843,1.77635684e-15 15.0822171,1.77635684e-15 L4.96277136,1.77635684e-15 C4.68942263,1.77635684e-15 4.46424942,0.200554273 4.42240185,0.462355658 C2.32674365,0.729284065 0.7,2.52004619 0.7,4.68734411 C0.7,6.87284065 2.35362587,8.67722864 4.47505774,8.92036952 C4.72909931,10.7305312 5.84577367,12.2666513 7.39976905,13.0927483 L7.39976905,17.2064665 L6.38595843,17.2064665 C6.08286374,17.2064665 5.83709007,17.4521478 5.83709007,17.7554273 L5.83709007,19.4429561 C5.83709007,19.7460508 6.08281755,19.9918245 6.38595843,19.9918245 L13.6593533,19.9918245 C13.962448,19.9918245 14.2082217,19.746097 14.2082217,19.4429561 L14.2082217,17.7554273 C14.2082217,17.4522402 13.9624942,17.2064665 13.6593533,17.2064665 L12.645358,17.2064665 L12.645358,13.0927483 C14.1993533,12.2666513 15.3160277,10.7308545 15.5704388,8.92036952 Z M13.1103002,18.8940416 L6.93496536,18.8940416 L6.93496536,18.3042956 L13.1103002,18.3042956 L13.1103002,18.8940416 L13.1103002,18.8940416 Z M18.2474365,4.68734411 C18.2474365,6.24517321 17.1151963,7.54050808 15.6311778,7.80161663 L15.6311778,1.57311778 C17.1152425,1.83418014 18.2474365,3.1295612 18.2474365,4.68734411 Z M1.79792148,4.68734411 C1.79792148,3.12951501 2.93011547,1.83418014 4.41394919,1.57307159 L4.41394919,7.80161663 C2.93002309,7.54055427 1.79792148,6.24517321 1.79792148,4.68734411 Z M5.51177829,8.13847575 L5.51177829,1.09792148 L14.5333025,1.09792148 L14.5333025,8.13847575 C14.5333025,10.6259122 12.5099307,12.6494226 10.0226328,12.6494226 C7.53533487,12.6494226 5.51177829,10.6259122 5.51177829,8.13847575 Z M11.5474365,17.1287298 L8.49745958,17.1287298 L8.49745958,13.5309931 C8.98318707,13.6684988 9.49357968,13.7473441 10.0226328,13.7473441 C10.5518245,13.7473441 11.061709,13.6684988 11.5474365,13.5312702 L11.5474365,17.1287298 L11.5474365,17.1287298 Z"></path>
                    </svg>
                </span>
                <span class="name">{{formatMultipleCategory(getTaxFromPost('education_level'))}}</span>

            </li>
            <li v-if="currentPage.acf.work_place && currentPostType === 'professions'">
                <span class="icon">
                    <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <circle fill="#fff"  cx="15" cy="15" r="15"></circle>
                        <g transform="translate(12.000000, 5.000000)">
                            <path fill="#005782" transform="translate(-4.000000, 0.000000)"  d="M6.55194805,0 C2.9587013,0 0.035012987,2.92358442 0.035012987,6.51683117 C0.035012987,9.80462338 5.27797403,18.5883117 5.87537662,19.5792208 C6.0185974,19.8159481 6.27506494,19.961039 6.55194805,19.961039 C6.82883117,19.961039 7.0852987,19.8159481 7.22836364,19.5792208 C7.82597403,18.5883636 13.0688831,9.80462338 13.0688831,6.51683117 C13.0688831,2.92363636 10.1451948,0 6.55194805,0 Z M6.55194805,17.6155844 C4.73225974,14.4678442 1.61485714,8.63444156 1.61485714,6.51693506 C1.61485714,3.79464935 3.82966234,1.58005195 6.55194805,1.58005195 C9.27423377,1.58005195 11.489039,3.79464935 11.489039,6.51693506 C11.489039,8.63366234 8.37163636,14.4674286 6.55194805,17.6155844 Z"></path>
                            <path fill="#005782" transform="translate(-2.000000, 2.000000)" d="M4.55194805,0.764363636 C2.4825974,0.764363636 0.799428571,2.44763636 0.799428571,4.51683117 C0.799428571,6.58623377 2.4825974,8.26935065 4.55194805,8.26935065 C6.62114286,8.26935065 8.30446753,6.58623377 8.30446753,4.51683117 C8.30446753,2.44768831 6.62114286,0.764363636 4.55194805,0.764363636 Z M4.55194805,6.68955844 C3.35392208,6.68955844 2.37927273,5.71490909 2.37927273,4.51688312 C2.37927273,3.31896104 3.35392208,2.34420779 4.55194805,2.34420779 C5.74987013,2.34420779 6.72462338,3.31901299 6.72462338,4.51688312 C6.72462338,5.71490909 5.74992208,6.68955844 4.55194805,6.68955844 Z"></path>
                        </g>
                    </svg>
                </span>
                <span class="name">{{formatMultipleCategory(getTaxFromPost('work_place'))}}</span>
            </li>
            <li class="interest" v-if="currentPage.acf.interests">
                <span class="icon">
                    <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <circle fill="#fff" cx="15" cy="15" r="15"></circle>
                        <path transform="translate(5.000000, 5.000000)" fill="#005782" d="M18.372124,2.12670185 C17.3228892,1.07741425 15.9280607,0.5 14.4441557,0.5 C12.9600396,0.5 11.5650528,1.07741425 10.5154485,2.12670185 L9.99840369,2.64385224 L9.48135884,2.12670185 C8.43207124,1.07741425 7.03676781,0.5 5.55296834,0.5 C4.06922164,0.5 2.67381266,1.07741425 1.62463061,2.12670185 C-0.541543536,4.29308707 -0.541543536,7.81788918 1.62463061,9.98343008 L9.38663588,17.7454881 C9.51354881,17.872876 9.67154354,17.9508707 9.8366095,17.9808971 C9.8919657,17.9918206 9.94763852,17.9968865 10.0034169,17.9968865 C10.2229947,17.9968865 10.442942,17.9131398 10.6101715,17.7454881 L18.3721768,9.98343008 C20.5384565,7.81788918 20.5384565,4.29308707 18.372124,2.12670185 Z M17.1586148,8.76997361 L9.99845646,15.9302375 L2.83813984,8.76997361 C1.34114776,7.27319261 1.34114776,4.83783641 2.83813984,3.34026385 C3.56325858,2.61525066 4.52769129,2.21646438 5.55296834,2.21646438 C6.57835092,2.21646438 7.54251979,2.61525066 8.26737467,3.34026385 L9.39164908,4.46490765 C9.71391821,4.78670185 10.2833113,4.78670185 10.6055277,4.46490765 L11.7293799,3.34026385 C12.4542876,2.61525066 13.4185092,2.21646438 14.4442084,2.21646438 C15.469591,2.21646438 16.4337071,2.61525066 17.1586148,3.34026385 C18.6557652,4.83783641 18.6557652,7.27313984 17.1586148,8.76997361 Z"></path>
                    </svg>
                </span>
                <span class="name" >
                    {{formatMultipleCategory(getTaxFromPost('interests'))}}
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { capitalize } from '@/helpers'

export default {
    name: 'header-categories',
    props: {
        
    },
    data(){
        return {
           
        }
    },
    mounted(){
        
    },
    methods:{
        getTaxName(taxonomy = 'work_place', id){
            if(!taxonomy || !id) return null;
            const taxonomies =  this.storedTaxonomy(taxonomy, id)
            if(taxonomies && taxonomies.name) return taxonomies.name
        },
        // List has to be a array
        getTaxFromPost(taxonomy = 'interests'){
            let ingr = [];
            if(this.currentPage && this.currentPage.acf && this.currentPage.acf[taxonomy]){
                ingr = this.currentPage.acf[taxonomy].map(e=> this.getTaxName(taxonomy, e))
            }
            return ingr
        },
        formatMultipleCategory(categories){
            const elements = categories.map((e, i) =>{
                return (i !==  0) ? e.toLowerCase() : capitalize(e);
            })
            return elements.join(', ').replace(/, ([^,]*)$/, ' og $1')
        }
    },
    computed:{
        ...mapGetters([
            'currentPostType',
            'currentPage',
            'storedTaxonomy'
        ]),
    },
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.post-categories{
    @include mquery($phone){
        padding-bottom: 0 !important;
    }
    .cat-list{
        margin: 0 auto;
        display: flex;
        justify-content: center;
        padding: 0px;
        max-width: 740px;
        @include mquery($phone){
            flex-wrap: wrap;
        }
        li{
            margin-left: 15px;
            margin-right: 15px;
            display: flex;
            align-items: center;
            flex-direction: column;
            flex-wrap: wrap;
            max-width: 33.33%;
            width: 100%;
            @include mquery($phone){
                flex-direction: row;  
                max-width: 100%;
                text-align: right;
                margin-top: 15px;
                .icon{
                    height: 30px;
                    width: 30px;
                    margin-right: 15px;
                }
            }
        }
    }
}
</style>